import { useState } from "react";

import {
    LookupVehicleCapDataError,
    LookupVehicleCapDataParams,
    LookupVehicleCapDataResponse,
    lookupVehicleCapData,
} from "services/motorpoint/partExchange";
import { logError } from "utils/logger";

const useVehicleCapData = () => {
    const [vehicleCapData, setVehicleCapData] = useState<LookupVehicleCapDataResponse | null>(null);
    const [vehicleCapDataError, setVehicleCapDataError] = useState<string | null>(null);

    const getVehicleCapData = async (
        params: LookupVehicleCapDataParams
    ): Promise<LookupVehicleCapDataResponse | LookupVehicleCapDataError | null> => {
        try {
            const { data } = await lookupVehicleCapData(params);

            if ((data as LookupVehicleCapDataError)?.Message) {
                setVehicleCapDataError((data as LookupVehicleCapDataError).Message);

                return null;
            }

            setVehicleCapData(data as LookupVehicleCapDataResponse);
            setVehicleCapDataError(null);

            return data;
        } catch (error) {
            logError("Failed to receive vehicle data.", error);
            setVehicleCapDataError("Failed to receive vehicle data.");

            return null;
        }
    };

    const resetVehicleCapData = () => {
        setVehicleCapData(null);
        setVehicleCapDataError(null);
    };

    return {
        vehicleCapData,
        vehicleCapDataError,
        setVehicleCapDataError,
        setVehicleCapData,
        getVehicleCapData,
        resetVehicleCapData,
    };
};

export default useVehicleCapData;
